function apiUrl(path: string[]): string {
  return path.join("/");
}

export default apiUrl;
